import { render, staticRenderFns } from "./CreateInvoiceClient.vue?vue&type=template&id=56760e76"
import script from "./CreateInvoiceClient.vue?vue&type=script&lang=js"
export * from "./CreateInvoiceClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports